<template>
  <div
    aria-live="assertive"
    class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
  >
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <transition
        enter-active-class="transition duration-300 ease-out transform"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="show && flash && !isLocal"
          class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
        >
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <CheckCircleIcon
                  class="h-6 w-6 text-green-400"
                  aria-hidden="true"
                  v-if="flash.type === 'success'"
                />
                <ExclamationCircleIcon
                  class="h-6 w-6 text-red-400"
                  aria-hidden="true"
                  v-if="flash.type === 'error'"
                />
                <ExclamationCircleIcon
                  class="h-6 w-6 text-yellow-400"
                  aria-hidden="true"
                  v-if="flash.type === 'warning'"
                />
                <ExclamationCircleIcon
                  class="text-info-400 h-6 w-6"
                  aria-hidden="true"
                  v-if="flash.type === 'info'"
                />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900">{{ flash.title }}</p>
                <p class="mt-1 text-sm text-gray-500">{{ flash.description }}</p>
              </div>
              <div class="ml-4 flex flex-shrink-0">
                <button
                  @click="show = false"
                  class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span class="sr-only">Close</span>
                  <XIcon
                    class="h-5 w-5"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {CheckCircleIcon, ExclamationCircleIcon} from '@heroicons/vue/outline';
import {XIcon} from '@heroicons/vue/solid';

export default {
  props: {
    flash: Object,
  },
  components: {
    CheckCircleIcon,
    ExclamationCircleIcon,
    XIcon,
  },
  data() {
    return {
      show: false,
      timeout: null,
    };
  },
  watch: {
    flash: {
      deep: true,
      handler() {
        this.show = true;
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => (this.show = false), 3000);
      },
    },
  },
  computed: {
    isLocal() {
      return this.flash?.local ?? false;
    },
  },
};
</script>
